import {
  Box,
  Button,
  Checkbox,
  Flex,
  Icon,
  IconButton,
  Image,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { IoClose } from "react-icons/io5";
import ReferQrcode from "../../pages/ReferCode/components/referQrcode";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { CLEAR_SOCKET_MESSAGE, notice } from "../../redux/action/action";
import Cookies from "js-cookie";
import { cancelTransfer } from "../../api/postApi";
import { COMMON_WEB_PATH } from "../../constant";
import { ImSpinner6 } from "react-icons/im";

const ClearCashButTransfer = ({ transCode = "", onCancelClearCash } = {}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const [qrcodeModal, setQrcodeModal] = useState(false);
  const [alreadyScan, setAlreadyScan] = useState(false);
  const [errorScan, setErrorScan] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const didUnmount = useRef(false);

  const dispatch = useDispatch();
  const isTriggerGivenUpPoint = useSelector(
    (state) => state.isTriggerGivenUpPoint
  );
  const isSocketMessage = useSelector((state) => state.isSocketMessage);
  const isMemberInfo = useSelector((state) => state.isMemberInfo);

  const { cagent_uid } = isMemberInfo || {};

  const { message, show } = isSocketMessage || {};

  const handleChecked = (e) => {
    setAlreadyScan(e.target.checked);
  };

  const handleCloseQrcodeModal = () => {
    // if (!alreadyScan) {
    //   dispatch(
    //     notice({
    //       title: i18n("請勾選“我已經掃描QR碼了”"),
    //       content: "",
    //       type: "error",
    //     })
    //   );
    // } else {
    //   setQrcodeModal(false);
    // }
    dispatch(CLEAR_SOCKET_MESSAGE());
    dispatch({ type: "GET_BALANCE" });
    setQrcodeModal(false);
    onCancelClearCash();
  };

  //後悔棄分轉點要取消轉移
  const goCancelTransfer = async () => {
    if (isLoading) return; // 防止重複點擊
    setIsLoading(true);

    try {
      await cancelTransfer({ transCode });
      dispatch(
        notice({
          title: i18n("取消點數轉移成功"),
          content: "",
          type: "success",
        })
      );

      dispatch(CLEAR_SOCKET_MESSAGE());
      dispatch({ type: "GET_BALANCE" }); //重新取餘額
      setQrcodeModal(false);
      onCancelClearCash();
    } catch (error) {
      dispatch(
        notice({
          title: i18n("取消點數轉移失敗"),
          content: error?.response?.data?.message || i18n("請稍後再試"),
          type: "error",
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  const lineApiUrl = useMemo(() => {
    const cli_id = process.env.REACT_APP_LINE_CLIENT_ID;
    return `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${cli_id}&redirect_uri=${process.env.REACT_APP_API_URL}/tw/signin&scope=profile&state=${transCode}`;
  }, [transCode]);

  const lineApiVersion2Url = useMemo(() => {
    return `https://liff.line.me/2006738953-n17g6VKb?trans_code=${transCode}`;
  }, [transCode, cagent_uid]);

  const normalApiUrl = useMemo(() => {
    return `${window.location.origin}/tw/signin?trans_code=${transCode}&invite_code=${cagent_uid}`;
  }, [transCode, cagent_uid]);

  useEffect(() => {
    if (transCode) {
      setQrcodeModal(true);
    }
  }, [transCode]);

  useEffect(() => {
    if (isTriggerGivenUpPoint) {
      setQrcodeModal(false);
      dispatch(
        notice({
          title: i18n("轉移成功！！"),
          content: "",
          type: "success",
        })
      );
    }
  }, [isTriggerGivenUpPoint]);

  useEffect(() => {
    //INIT
    dispatch(CLEAR_SOCKET_MESSAGE());
  }, []);

  useEffect(() => {
    if (message && show) {
      setErrorScan(true);
    }
  }, [message, show]);

  return (
    qrcodeModal && (
      <Box
        bg="rgba(0,0,0,0.8)"
        position="absolute"
        top="0"
        left="0"
        w="100%"
        h="100%"
        display="flex"
        flexDirection="column"
        alignItems={"center"}
        justifyContent={"center"}
        gap={5}
        zIndex={5}
      >
        {/* {errorScan ? null : (
          <Box alignSelf={"flex-end"}>
            <IconButton onClick={goCancelTransfer} fontSize="40px">
              <IoClose />
            </IconButton>
          </Box>
        )} */}
        {!isLoading ? (
          <Text fontSize="xl" fontWeight={700}>
            {i18n("請務必掃描轉移QRCODE！！")}
          </Text>
        ) : null}
        {errorScan ? null : (
          <Flex gap={10} alignItems="center">
            {/* <Flex direction={"column"} alignItems={"center"} gap={2}>
            <Text>{i18n("LINE登入")}</Text>
            <Box p={2} borderRadius={2} bg="white">
              <a className="cursor-pointer" href={lineApiUrl}>
                <ReferQrcode
                  className={{
                    w: "150px",
                    h: "150px",
                  }}
                  value={lineApiUrl}
                />
              </a>
            </Box>
          </Flex> */}
            {isLoading ? (
              <Flex alignItems={"center"} justifyContent={"center"}>
                <Icon
                  as={ImSpinner6}
                  fontSize={"30px"}
                  className="animate-spin"
                  color="yellow.500"
                />
              </Flex>
            ) : (
              <Flex direction={"column"} alignItems={"center"} gap={2}>
                <Text>{i18n("LINE登入")}</Text>
                <Box p={2} borderRadius={2} bg="white">
                  <a className="cursor-pointer" href={lineApiVersion2Url}>
                    <ReferQrcode
                      className={{
                        w: "150px",
                        h: "150px",
                      }}
                      value={lineApiVersion2Url}
                    />
                  </a>
                </Box>
                <Box
                  mt={2}
                  justifyContent="center"
                  alignItems="center"
                  onClick={goCancelTransfer}
                  _hover={{
                    filter: "brightness(1.2)",
                  }}
                  cursor="pointer"
                >
                  <Image
                    w="120px"
                    h="50px"
                    src={`${COMMON_WEB_PATH}/911TW/cancelBTN.webp`}
                    isLoading={isLoading}
                    disabled={isLoading}
                  />
                </Box>
              </Flex>
            )}
            {/* <Flex direction={"column"} alignItems={"center"} gap={2}>
              <Text>{i18n("一般登入")}</Text>
              <Box p={2} borderRadius={2} bg="white">
                <a className="cursor-pointer" href={normalApiUrl}>
                  <ReferQrcode
                    className={{
                      w: "150px",
                      h: "150px",
                    }}
                    value={normalApiUrl}
                  />
                </a>
              </Box>
            </Flex> */}
          </Flex>
        )}

        {errorScan ? (
          <>
            <Text fontSize="xl" fontWeight={700} color="red.500">
              {i18n(message)}
            </Text>
            <Button variant={"brandPrimary"} onClick={handleCloseQrcodeModal}>
              {i18n("關閉重試")}
            </Button>
          </>
        ) : null}
        {/* <Checkbox
          colorScheme="yellow"
          size="lg"
          onChange={handleChecked}
          checked={alreadyScan}
          sx={{
            background:
              "linear-gradient(180deg, #fff 0%,#fdd26a 60%,  #b07f20 80%,  #b07f20 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            textShadow: "0px 1px 3px rgba(255, 215, 0, 0.4)",
            fontSize: "20px",
            fontWeight: 700,
          }}
        >
          {i18n("我已經掃描QRCODE了")}
        </Checkbox> */}
      </Box>
    )
  );
};

export default ClearCashButTransfer;
